import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Link } from '@mui/material';

// Link pra tela Show de uma entidade (cliente, abastecimento, desconto). Regra do admin:
// sempre que a entidade tem Show, o nome/CPF/identificador leva pra ela. Link de verdade
// (href), então ctrl/cmd-clique abre em nova aba; o clique não dispara o rowClick da linha.
const ShowLink: React.FC<{ to: string; children: React.ReactNode }> = ({ to, children }) => (
  <Link component={RouterLink} to={to} underline="hover" onClick={(e: React.MouseEvent) => e.stopPropagation()}>
    {children}
  </Link>
);

export default ShowLink;
